import React from 'react'
import HeaderTopSection1 from '../../HedaerTopSection/HeaderTopSection1'
import HeaderBottomSection1 from '../../HeaderBottomSection/HeaderBottomSection1'
import HeaderMiddleSection1 from '../../HeaderMiddleSection/HeaderMiddleSection1'
import classNames from 'classnames'
import { useLocation } from 'react-router-dom'

const Header1 = () => {
  const location = useLocation()
  return (
    <header className='relative z-50'>
        <div className={classNames('w-full',location.pathname === "/" ? 'bg-transparent' : 'bg-midNightExpress-1')}>
            <HeaderTopSection1 />
        </div>
        <div>
            <HeaderMiddleSection1 />
        </div>
        <div>
            <HeaderBottomSection1 />
        </div>
    </header>
  )
}

export default Header1